<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix">
          <b-button
            class="pull-left"
            size="sm"
            variant="primary"
            @click="submitExport()"
          >
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            全部导出
          </b-button>
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.contentKeyword"
              placeholder="请输入搜索内容"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.status"
              class="form-select"
              :options="statusList"
              type="text"
            ></b-form-select>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive">
            <table
              class="table project-list-table table-nowrap table-centered table-borderless align-middle table-hover"
            >
              <thead>
                <tr>
                  <!-- <th scope="col" style="width: 70px;">
                    <b-form-checkbox
                      @change="checkedAll" 
                      v-model="indeterminate" 
                      checked
                      plain
                      ></b-form-checkbox>
                  </th> -->
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col" class="w-300">优惠券码</th>
                  <th scope="col">用户昵称</th>
                  <th scope="col">手机号</th>
                  <th scope="col">所属商家</th>
                  <th scope="col">状态</th>
                  <th scope="col">发放日期</th>
                  <th scope="col"><span class="px-2">操作</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <!-- <td>
                    <b-form-checkbox
                      v-model="choiceListIds" 
                      :value="item.id" 
                      checked
                      plain
                      ></b-form-checkbox>
                  </td> -->
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">{{ item.code }}</td>
                  <td>{{ item.member ? item.member.nickname : "--" }}</td>
                  <td>{{ item.member ? item.member.phone : "--" }}</td>
                  <td>
                    {{
                      item.merchant
                        ? item.merchant.name
                          ? item.merchant.name
                          : "--"
                        : "--"
                    }}
                  </td>
                  <td>
                    <span v-if="item.status == 1">可用</span>
                    <span v-if="item.status == 0">不可用</span>
                  </td>
                  <td>{{ item.createdAt || "--" }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn-sm btn btn-warning m-r-10"
                      @click="showModel(item)"
                    >
                      核销
                    </button>
                    <button
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="showModel(item, true)"
                    >
                      作废
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination ref="page" @pageCallback="pageCallback"></pagination>
        </div>
        <app-list-loading ref="loading"></app-list-loading>
      </div>
    </div>

    <el-dialog
      :title="isVerific ? '确认作废该优惠券吗？' : '确认核销该优惠券吗？'"
      :visible.sync="show"
      class="top-draft-dialog cpupon-verific-dialog"
      :before-close="handleClose"
    >
      <div class="card" style="margin-bottom: 0">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>优惠码</label>
              <div class="label">
                {{ currentItem.code || "--" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>所属商家</label>
              <div class="label">
                {{
                  currentItem.merchant
                    ? currentItem.merchant.name
                      ? currentItem.merchant.name
                      : "--"
                    : "--"
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>备注</label>
              <textarea
                v-model="currentItem.remark"
                class="form-control"
                rows="5"
                placeholder="请输入备注"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitPreserve()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue";
import conpon from "../../../../server/api/coupons";

/**
 * Contacts-list component
 */
export default {
  components: {
    pagination,
  },

  props: {
    tagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      show: false,
      isVerific: false,
      pageParams: {
        page: 1,
        pageSize: 30,
        status: "",
        contentKeyword: "",
      },
      currentItem: {},
      items: [],
      index_id: "",
      statusList: [
        { text: "筛选状态", value: "" },
        { text: "可用", value: "1" },
        { text: "不可用", value: "0" },
      ],
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    // 获取详情
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id;
      this.getList();
    }
  },

  created() {},

  methods: {
    //获取列表数据
    getList() {
      let paramsUrl = {
        id: this.index_id,
        page: this.pageParams.page,
        pageSize: this.pageParams.pageSize,
        "q%5Breceived%5D": 1,
        "q%5Bstatus%5D": this.pageParams.status,
        "q%5Bkeywords%5D": this.pageParams.contentKeyword,
      };
      let params = this.utils.getQuery(paramsUrl);
      this.$refs.loading.show();
      this.items = [];
      conpon.codes(params).then((resp) => {
        if (resp.code == 0) {
          if (this.$refs.loading) {
  this.$refs.loading.hide(resp.data.items);
}
          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
              if (item.createdAt) {
                item.createdAt = this.utils.getTimeStamp(item.createdAt);
              }
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
              if (this.$refs.page) {
                this.$refs.page.setPages(pages);
              }
            });
          }
        } else {
          if (this.$refs.loading) {
  this.$refs.loading.hide();
}
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    showModel(item, isVerific) {
      if (isVerific) {
        this.isVerific = true;
      } else {
        this.isVerific = false;
      }
      this.currentItem = item;
      this.currentItem.remark = "";
      this.show = true;
    },

    handleClose() {
      this.show = false;
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.status = "";
      this.pageParams.contentKeyword = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    submitExport() {
      function createObjectURL(object) {
        return window.URL
          ? window.URL.createObjectURL(object)
          : window.webkitURL.createObjectURL(object);
      }
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      let url =
        env.API_HOST +
        "/create-platform/coupon/codes/export?couponId=" +
        this.index_id;
      url = url + "&q%5Breceived%5D=1&";
      if (this.pageParams.status) {
        url = url + "q%5Bstatus%5D=" + this.pageParams.status;
      }
      if (this.pageParams.contentKeyword) {
        url = url + "&q%5Bkeywords%5D=" + this.pageParams.contentKeyword;
      }
      xhr.open("get", url);
      xhr.setRequestHeader("x-auth-token", this.cookies.getCookie("token"));
      xhr.responseType = "blob";
      xhr.onload = function(e) {
        if (this.status == 200) {
          var blob = this.response;
          var filename = "领用列表.xlsx";
          console.log(this.response);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement("a");
            var url = createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(formData);
    },

    submitPreserve() {
      let params = {};
      params.code = this.currentItem.code;
      params.remark = this.currentItem.remark;
      if (this.isVerific) {
        //作废
        params.merchantID = this.currentItem.merchantId;
        conpon.discard(params).then((resp) => {
          if (resp.code == 0) {
            this.handleClose();
            Vue.swal({
              icon: "success",
              title: "作废成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getList();
          } else {
            // this.handleClose()
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      } else {
        //核销
        conpon.verify(params).then((resp) => {
          if (resp.code == 0) {
            this.handleClose();
            Vue.swal({
              icon: "success",
              title: "核销成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getList();
          } else {
            // this.handleClose()
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.cpupon-verific-dialog .el-dialog {
  width: 450px !important;
  height: auto !important;
  border-radius: 6px;
  margin-top: 0 !important;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  max-height: 90vh;
}

.cpupon-verific-dialog .el-dialog__body {
  background: #fff;
}
</style>
